export default __webpack_public_path__ + "static/media/annalisenew.1785018f.webp";